module.exports = __webpack_public_path__ + "media/pages/book/components/images/main-features/headphones-28aa1d78a527f060d12214dc0c36893e.svg";